const buttonFormActions = {
  cancel: 'Cancel action',
  reopen: 'Reopen action',
  done: 'Complete action'
};

export default buttonFormActions;
